import 'idempotent-babel-polyfill'
import React from 'react'
import ReactDOM from 'react-dom'
import { SENTRY_URL } from 'config'
import SmoothScroll from 'smoothscroll-polyfill'

import { EnterpriseRoutes, HomeRoutes, AdvancedRoutes } from './routes'
import { SimpleRoutesV2, FeedbackRoutes, RatingRoutes } from './routesV2'

import 'react-flexbox-grid/dist/react-flexbox-grid.css'
import 'react-dates/lib/css/_datepicker.css'
import 'react-datetime/css/react-datetime.css'
import 'rc-tooltip/assets/bootstrap.css'

import './index.css'

global._babelPolyfill = false

// Smoothscroll polyfill
SmoothScroll.polyfill()

// Sentry
if (
  process.env.NODE_ENV !== 'development' &&
  process.env.NODE_ENV !== 'localhost'
) {
  const sentryConfig = {
    name: process.env.ADENE_ENV,
  }

  const Raven = require('raven-js')
  const LogRocket = require('logrocket')
  LogRocket.init('cau4dx/poupaenergia')

  Raven.setDataCallback(function(data) {
    data.extra.sessionURL = LogRocket.sessionURL
    return data
  })

  Raven.config(SENTRY_URL, sentryConfig).install()
}

// Render elements
const advanced = document.getElementById('adene-simulador-avancado')
const simple = document.getElementById('adene-simulador-simples')
const enterprise = document.getElementById('adene-simulador-empresarial')
const home = document.getElementById('adene-simulador-home')
const feedback = document.getElementById('adene-simulador-feedback')
const rating = document.getElementById('adene-simulador-rating')

// Renders the advanced simulator
if (advanced) {
  ReactDOM.render(<AdvancedRoutes />, advanced)

  if (module.hot) {
    module.hot.accept('./routes', () => {
      const Next = require('./routes').AdvancedRoutes
      ReactDOM.render(<Next />, advanced)
    })
  }
}

// Renders the simple simulator
if (simple) {
  ReactDOM.render(<SimpleRoutesV2 />, simple)

  if (module.hot) {
    module.hot.accept('./routesV2', () => {
      const Next = require('./routesV2').SimpleRoutesV2
      ReactDOM.render(<Next />, simple)
    })
  }
}

// Renders the simple simulator
if (enterprise) {
  ReactDOM.render(<EnterpriseRoutes />, enterprise)

  if (module.hot) {
    module.hot.accept('./routes', () => {
      const Next = require('./routes').EnterpriseRoutes
      ReactDOM.render(<Next />, enterprise)
    })
  }
}

if (home) {
  ReactDOM.render(<HomeRoutes />, home)

  if (module.hot) {
    module.hot.accept('./routes', () => {
      const Next = require('./routes').HomeRoutes
      ReactDOM.render(<Next />, home)
    })
  }
}

// Renders the standalone feedback survey (embeddable micro-service)
if (feedback) {
  ReactDOM.render(<FeedbackRoutes />, feedback)

  if (module.hot) {
    module.hot.accept('./routesV2', () => {
      const Next = require('./routesV2').FeedbackRoutes
      ReactDOM.render(<Next />, feedback)
    })
  }
}

// Renders the standalone adhesion rating survey (embeddable micro-service)
if (rating) {
  ReactDOM.render(<RatingRoutes />, rating)

  if (module.hot) {
    module.hot.accept('./routesV2', () => {
      const Next = require('./routesV2').RatingRoutes
      ReactDOM.render(<Next />, rating)
    })
  }
}



// WEBPACK FOOTER //
// ./src/index.js